/**
 * KAN-858: "Бот напишет" в карточке клиента приложения менеджера: строка
 * кабинета NextBotTouchNote (когда по времени организации, шаг, что напишет,
 * "Отправить сейчас", "Показать текст" / "Другой вариант") и "Не писать".
 * Касания нет: ничего.
 */
import { NextBotTouchNote } from '@/components/clients/NextBotTouchNote';
import type { Client } from '@/types/client';

export function MobileNextBotTouch({ client }: { client: Pick<Client, 'id' | 'next_bot_touch'> }): JSX.Element | null {
  if (!client.next_bot_touch) return null;
  return (
    <section className="space-y-2 rounded-xl border border-gray-200 bg-white p-4" data-testid="mobile-next-bot-touch">
      <h2 className="text-base font-semibold text-gray-900">Бот напишет</h2>
      <NextBotTouchNote clientId={client.id} touch={client.next_bot_touch} allowCancel />
    </section>
  );
}
